import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon'
import { MatSnackBar } from '@angular/material/snack-bar';
import { DOCUMENT } from '@angular/common';


@Component({
  imports: [MatIconModule],
  selector: 'app-claude-desktop',
  templateUrl: './claude-desktop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './claude-desktop.css'
})
export class ClaudeDesktop  {
  url: string;
 
  private document = inject(DOCUMENT);
  private snackBar = inject(MatSnackBar);
    
  constructor() {
        this.url = `${this.document.location.protocol}//${this.document.location.hostname}${this.document.location.port?":"+this.document.location.port:""}`
  }

  copyJson(element: HTMLTextAreaElement): void {
    navigator.clipboard.writeText(element.value)
      .then(() => this.snackBar.open('Copied to clipboard!', 'Close', { duration: 2000 }))
      .catch(err => this.snackBar.open('Failed to copy: ' + err, 'Close', { duration: 2000 }));
  }
}
